<template>
  <div>
    <div class="searchHead">
      <div class="numGroup">
        <i class="el-icon-data-line"></i>
        <div class="numGroupNum">
          <div class="margin-border">
            <span class="numGroupNumFir">{{ data.totalMedia[1] | numFormate }}</span>
            <i v-if="dataup" class="el-icon-caret-top"></i>
            <i v-if="!dataup" class="el-icon-caret-bottom"></i>
            <span class="numGroupNumSec">{{ data.totalMedia[1] - data.totalMedia[0] }}</span>
          </div>
          <p class="margin-border">The number of overseas websites monitored</p>
        </div>
      </div>
      <div class="numGroup">
        <i class="el-icon-office-building"></i>
        <div class="numGroupNum">
          <div class="margin-border">
            <span class="numGroupNumFir point" @click="toList('1')">{{ data.totalCompany[1] | numFormate }}</span>
            <i v-if="dataup" class="el-icon-caret-top"></i>
            <i v-if="!dataup" class="el-icon-caret-bottom"></i>
            <span class="numGroupNumSec">{{ data.totalCompany[1] - data.totalCompany[0] }}</span>
          </div>
          <p class="margin-border">The number of Chinese Enterprises tracked</p>
        </div>
      </div>
      <div class="numGroup">
        <i class="el-icon-document"></i>
        <div class="numGroupNum">
          <div class="margin-border">
            <span class="numGroupNumFir point" @click="toList('2')">{{ data.totalArticle[1] | numFormate }}</span>
            <i v-if="dataup" class="el-icon-caret-top"></i>
            <i v-if="!dataup" class="el-icon-caret-bottom"></i>
            <span class="numGroupNumSec">{{ data.totalArticle[1] - data.totalArticle[0] }}</span>
          </div>
          <p class="margin-border">The volume of valid data


            <!--            <el-popover v-model="bool.showTSID" placement="bottom-end" trigger="click" width="200">
                      <span class="popoverContent">
                        <span class="popoverContentFir">Total station information data</span>
                        <span>{{ data.totalSourceArticle[1] | numFormate }}</span>
                      </span>
                          <i slot="reference" class="el-icon-question"></i>
                        </el-popover>-->


          </p>
        </div>
        <!--        <el-popover v-model="bool.showTSID" placement="bottom-end" trigger="click" width="200">
                  <div class="popoverContent">
                    <span class="popoverContentFir">Total station information data</span>
                    <span>{{ data.totalSourceArticle[1] }}</span>
                  </div>
                  <i slot="reference" class="el-icon-question"></i>
                </el-popover>-->
      </div>

      <div class="searchElInput">
        <el-input v-model="searchInput" placeholder="Please enter keywords separated by Spaces."
                  prefix-icon="el-icon-search" @keyup.enter.native="goSearch"/>
      </div>
      <el-popover placement="bottom-end" trigger="click" width="600">
        <div>
          <span class="popoverSpan">
            The system mainly tracks the Chinese brand activities in more than
            600 overseas mainstream media, with the aim to reflect brand
            building overseas. The brands selected by Xinhua are in line with
            the development concept of "innovation, coordination, green
            development, openness and sharing" and the spirit of craftsmanship
            and entrepreneurship.</span
          >
        </div>
        <div slot="reference" class="moduleIntroduction">
          <div>Module</div>
          <div>Introduction</div>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import request from "@/views/brand/utils/request";

export default {
  data() {
    return {
      bool: {showTSID: false},
      data: {totalMedia: [0, 0], totalCompany: [0, 0], totalArticle: [0, 0], totalSourceArticle: [0, 0]},
      dataup: true,
      searchInput: "",
    }
  },
  filters: {
    numFormate(value) {
      return value.toLocaleString();
    }
  },
  watch: {
    'bool.showTSID'(newVal) {
    }
  },
  mounted() {

  },
  methods: {
    goSearch() {
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")

        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });

        return
      }
      this.$router.push({path: 'search', query: {keywords: this.searchInput}})
    },
    getCount() {
      request({method: 'get', url: '/api/client/chinaEnterprise/totalMedia'}).then(result => {
        this.data.totalMedia = result.data
      })
      request({method: 'get', url: '/api/client/chinaEnterprise/totalCompany'}).then(result => {
        this.data.totalCompany = result.data
      })
      request({method: 'get', url: '/api/client/chinaEnterprise/totalArticle'}).then(result => {
        this.data.totalArticle = result.data
      })
      request({method: 'get', url: '/api/client/chinaEnterprise/totalSourceArticle'}).then(result => {
        this.data.totalSourceArticle = result.data
      })
    },
    toList(tabIndex) {
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      this.$router.push({path: '/search', query: {showTab: tabIndex}});
    }
  }
};
</script>

<style scoped>
.searchHead {
  display: flex;
  align-items: center;
}

.numGroup {
  margin-left: 15px;
  width: 380px;
  display: flex;
}

.margin-border {
  margin-left: 20px;
}

.margin-border /deep/ .el-icon-question {
  margin-top: unset;
}

.numGroupNum {
  display: flex;
  /*font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑;*/
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  color: #2f8eff;
  border-left: 1.5px solid #2f8eff;
  margin-left: 20px;
}

.numGroupNum .numGroupNumFir {
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  vertical-align: baseline;
  margin-right: 5px;
}
.numGroupNum .point {
  cursor: pointer;
}

.numGroupNum .numGroupNumSec {
  font-size: 12px;
}

.numGroupNum p {
  font-size: 12px;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
}

.el-icon-question {
  margin-top: 40px;
  margin-left: 5px;
  color: #2f8eff;
  cursor: pointer;
}

.el-icon-data-line,
.el-icon-office-building,
.el-icon-document {
  padding: 10px;
  /*height: 45px;*/
  font-size: 45px;
  color: #2f8eff;
  background: #409eff70;
}

.popoverContent {
  display: flex;
  align-items: center;
}

.popoverContent span {
  color: #2f8eff;
  font-size: 12px;
}

.popoverContent .popoverContentFir {
  width: 120px;
  margin-right: 10px;
}

.searchElInput {
  margin-left: 15px;
  width: 640px;
}

.searchElInput /deep/ .el-input__inner {
  height: 60px;
  font-size: 18px;
  border-color: #2f8eff;
  padding-left: 60px;
}

.searchElInput /deep/ .el-input__icon {
  font-size: 35px;
  color: #2f8eff;
  /*margin-top: 10px;*/
  width: unset;
  margin-left: 10px;
  font-weight: 700;
}

.moduleIntroduction {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 20px;
  color: #2f8eff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  margin-right: 10px;
}

.popoverSpan {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  letter-spacing: 0.6px;
  color: #555555;
}
</style>
